import React from 'react';
import { Outlet } from 'react-router-dom';

import ScrollToTop from '@app/components/LocalCommon/ScrollToTop/ScrollToTop';
import FindVetBlock from '@app/components/UI/FindVetBlock/FindVetBlock';
import Footer from '@app/components/UI/Footer/Footer';
import Header from '@app/components/UI/Header/Header';
import '@app/scss/components/chat.scss';
import '@app/scss/style.scss';

interface PageProps {
	withScrollTop?: boolean;
}

const Layout: React.FC<PageProps> = ({ withScrollTop = true }) => {
	return (
		<div className="app-container">
			<Header />
			<div className="app-container-content">
				<Outlet />
			</div>
			<FindVetBlock />
			<Footer />
			{withScrollTop && <ScrollToTop />}
		</div>
	);
};

export default Layout;
